export const FETCH_JOB_BID_REQUEST = 'FETCH_JOB_BID_REQUEST';
export const FETCH_JOB_BID_SUCCESS = 'FETCH_JOB_BID_SUCCESS';
export const FETCH_JOB_BID_FAIL = 'FETCH_JOB_BID_FAIL';

export const CREATE_JOB_BID_REQUEST = 'CREATE_JOB_BID_REQUEST';
export const CREATE_JOB_BID_SUCCESS = 'CREATE_JOB_BID_SUCCESS';
export const CREATE_JOB_BID_FAIL = 'CREATE_JOB_BID_FAIL';

export const UPDATE_JOB_BID_REQUEST = 'UPDATE_JOB_BID_REQUEST';
export const UPDATE_JOB_BID_SUCCESS = 'UPDATE_JOB_BID_SUCCESS';
export const UPDATE_JOB_BID_FAIL = 'UPDATE_JOB_BID_FAIL';

export const DELETE_JOB_BID_REQUEST = 'DELETE_JOB_BID_REQUEST';
export const DELETE_JOB_BID_SUCCESS = 'DELETE_JOB_BID_SUCCESS';
export const DELETE_JOB_BID_FAIL = 'DELETE_JOB_BID_FAIL';
